/**
 * アクションタイプ
 */
export var StatableActionType;

(function (StatableActionType) {
  /**
   * 未選択
   */
  StatableActionType[StatableActionType["None"] = -1] = "None";
  /**
  * 可視性OFF
  */

  StatableActionType[StatableActionType["VisibilityOff"] = 0] = "VisibilityOff";
  /**
  * 再生OFF
  */

  StatableActionType[StatableActionType["PlayOff"] = 1] = "PlayOff";
  /**
  * ボイスメモOFF
  */

  StatableActionType[StatableActionType["VoiceMemoOff"] = 2] = "VoiceMemoOff";
  /**
  * ロックOFF
  */

  StatableActionType[StatableActionType["LockOff"] = 5] = "LockOff";
  /**
  * 重力OFF
  */

  StatableActionType[StatableActionType["GravityOff"] = 6] = "GravityOff";
  /**
   * チャットボットOFF
   */

  StatableActionType[StatableActionType["ChatBotOff"] = 7] = "ChatBotOff";
  /**
   * イマーシブOFF
   */

  StatableActionType[StatableActionType["ImmersiveOff"] = 8] = "ImmersiveOff";
  /**
   * 切り替えない
   */

  StatableActionType[StatableActionType["SwitchGroupOff"] = 13] = "SwitchGroupOff";
  /**
  * 可視性ON
  */

  StatableActionType[StatableActionType["VisibilityOn"] = 100] = "VisibilityOn";
  /**
  * 再生ON
  */

  StatableActionType[StatableActionType["PlayOn"] = 101] = "PlayOn";
  /**
  * ボイスメモOFF
  */

  StatableActionType[StatableActionType["VoiceMemoOn"] = 102] = "VoiceMemoOn";
  /**
  * リセット
  */

  StatableActionType[StatableActionType["Reset"] = 103] = "Reset";
  /**
  * スケール
  */

  StatableActionType[StatableActionType["Scale"] = 104] = "Scale";
  /**
  * ロックON
  */

  StatableActionType[StatableActionType["LockOn"] = 105] = "LockOn";
  /**
  * 重力ON
  */

  StatableActionType[StatableActionType["GravityOn"] = 106] = "GravityOn";
  /**
   * チャットボットON
   */

  StatableActionType[StatableActionType["ChatBotOn"] = 107] = "ChatBotOn";
  /**
   * イマーシブON
   */

  StatableActionType[StatableActionType["ImmersiveOn"] = 108] = "ImmersiveOn";
  /**
   * 集合
   */

  StatableActionType[StatableActionType["Gather"] = 109] = "Gather";
  /**
   * 振動
   */

  StatableActionType[StatableActionType["Vibration"] = 110] = "Vibration";
  /**
   * ロールバック
   */

  StatableActionType[StatableActionType["Rollback"] = 111] = "Rollback";
  /**
   * 待機
   */

  StatableActionType[StatableActionType["Wait"] = 112] = "Wait";
  /**
   * 切り替える
   */

  StatableActionType[StatableActionType["SwitchGroupOn"] = 113] = "SwitchGroupOn";
})(StatableActionType || (StatableActionType = {}));